class MinimalHeader extends HTMLElement {
  constructor() {
    super();
    this.headerSection = this.closest('[data-section-type="minimal-header"]');
    this.setupEventListeners();
  }

  connectedCallback() {
    // Check if there are any visible sections with inverse header setting
    this.checkForInverseHeaders();
  }

  setupEventListeners() {
    // Listen for the header:invert custom event
    document.addEventListener('header:invert', this.handleHeaderInvert.bind(this));
    
    // Check for inverse headers on scroll
    window.addEventListener('scroll', this.checkVisibleSections.bind(this));
    
    // Initial check on page load
    document.addEventListener('DOMContentLoaded', this.checkForInverseHeaders.bind(this));
  }

  handleHeaderInvert(event) {
    if (event.detail && event.detail.invert) {
      this.headerSection.classList.add('inverted-header');
    } else {
      this.headerSection.classList.remove('inverted-header');
    }
  }

  checkForInverseHeaders() {
    // Find all sections that might have the inverse header data attribute
    const sectionsWithInverseHeader = document.querySelectorAll('[data-inverse-header="true"]');
    
    if (sectionsWithInverseHeader.length > 0) {
      // Check if any of them are visible
      this.checkVisibleSections();
    }
  }

  checkVisibleSections() {
    const sectionsWithInverseHeader = document.querySelectorAll('[data-inverse-header="true"]');
    let shouldInvert = false;
    
    sectionsWithInverseHeader.forEach(section => {
      const rect = section.getBoundingClientRect();
      const isVisible = (rect.top < window.innerHeight && rect.bottom >= 0);
      
      if (isVisible) {
        shouldInvert = true;
      }
    });
    
    // Dispatch the event with the determined state
    document.dispatchEvent(new CustomEvent('header:invert', { 
      detail: { invert: shouldInvert }
    }));
  }
}

// Register the custom element
customElements.define('minimal-header', MinimalHeader);
